
export enum FollowType
{
    Brands = 0,
    MarketPlaces = 1,
    Tags = 2,
    Channel = 3
}